<!--TODO Design and Implement Loading Bar modules-->

<template>
  <div class="bar">

  </div>
</template>

<script>
  export default {
    name: 'ProgressBar'
  }
</script>

<style scoped>
  @keyframes bar {
    0% {
      @apply bg-theme-secondary;
    }
    10% {
      @apply bg-theme-ternary;
    }
    /*20% {*/
    /*  background-color: #f0d386;*/
    /*}*/
    30% {
      @apply bg-theme-primary;
    }
    /*40% {*/
    /*  background-color: #f8d370;*/
    /*}*/
    50% {

      @apply bg-theme-abstract;
    }
    /*60% {*/
    /*  background-color: #c49d35;*/
    /*}*/
    70% {
      @apply bg-theme-secondary;
    }

    90% {
      @apply bg-theme-ternary;
    }
    100% {
      @apply bg-theme-abstract;
    }
  }

  div {
    animation-name: bar;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
</style>
